export default __webpack_public_path__ + "static/media/coffee-cup.c78aaa88.png";